import { PersonalInformation } from "./PersonalInformation"
import { RegisteredDevices } from "./RegisteredDevices"
import { SignInInformation } from "./SignInInformation"

export const AccountDetails = () => (
  <div className="flex flex-col gap-5">
    <PersonalInformation />
    <SignInInformation />
    <RegisteredDevices />
  </div>
)
